import React, { Component } from 'react';

import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { AppHelper } from '../../../helpers/AppHelper';
import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { AppConfig } from '../../../AppConfig';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { Controller } from '../../../common/Controller';

import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { css, StyleSheet } from 'aphrodite';
import { UiHelper } from '../../helpers/UiHelper';

export class CatsL3 extends BaseEntityPage {

  constructor(props) {
    super(props);
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.idl1 = this.props.match.params.idl1
    this.parentId = this.idl2 = this.props.match.params.idl2
    this.pageTitle = Helper.getString('level3')
    this.pageKey = 'catsL3'
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: Helper.getString('categories'), to: this.baseRoute() + '/cats' },
      { title: Helper.getString('level2'), to: this.baseRoute() + '/cats/' + this.idl1 },
      { title: Helper.getString('level3') },
    ]
    this.toFetch = [
      {
        method: 'GET', paths: ['cats'],
        queryParams: { orgId: this.orgId, parentId: this.parentId, pb: 'fieldDef,fieldDefSEO', limit: 200 }
      },
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['cats', this.parentId], { orgId: this.orgId }) },
    ]
    this.tableHeadersMap = {
      'Slug / ID': (current) => {
        return UiHelper.itemDetails(current)
      },
      Title: (current) => current.title,
      Status: (current) => {
        return UiHelper.itemStatusContainer(current)
      },
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      orgId: this.orgId,
      parentId: this.parentId
    }
  }

  onFetchSuccess(results) {
    this.fieldDef = results[0].fieldDef
    this.fieldDefSEO = results[0].fieldDefSEO
    this.pageTitle = results[1].title
    const fields = []
    for (const field of this.fieldDef.steps[0].fields) {
      if (field.key !== 'parentId') {
        fields.push(field)
      }
    }
    this.fieldDef.steps[0].fields = fields
    this.handleNextpage(results[0])
    this.setState({
      items: Helper.sortDictArray(this.state.items.concat(results[0].items), 'title')
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['cats'], { orgId: this.orgId }),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath(['cats', current.id], { orgId: this.orgId }),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['cats', current.id], { orgId: this.orgId }),
    });
  }

  openModalForAdd() {
    const fields = []
    this.fieldDef.steps[0].fields.forEach(i => { if (i.key !== 'slug') fields.push(i) })
    this.fieldDef = { steps: [{ fields }] }
    super.openModalForAdd(this.fieldDef)
  }

  onActions = (current) => {
    const actions = []
    actions.push(UiHelper.buttonEdit(this, current))
    actions.push(UiHelper.buttonSEO(this, current))
    actions.push(UiHelper.buttonDelete(this, current))
    actions.push(UiHelper.buttonOpenItemsInCat(this, current))
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  }
})